module.exports = __webpack_public_path__ + "img/NW06.21bb6f5a.gif";